// import Swiper from 'swiper';
import '@fancyapps/fancybox';
import AOS from 'aos';
import svg4everybody from 'svg4everybody';
import './components/jquery.sTabs';
import './components/remcalc';
import './components/quest';

(function($) {
  $(() => {
    svg4everybody();

    $('[data-fancybox]').fancybox({
      touch: false,
      onInit() {
        if ($.fancybox.isMobile) {
          $('body').css('top', $('body').scrollTop() * -1).addClass('fancybox-iosfix');
        }
      },
      afterClose() {
        let offset;

        if ($('body').hasClass('fancybox-iosfix')) {
          offset = parseInt(document.body.style.top, 10);

          $('body').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
        }
      }
    });


    AOS.init();
    $('.tabs').sTabs();

    $('.btn--burger').on('click', () => {
      $('.header').toggleClass('is-active');
    });


    $('.btn--sound').on('click', function() {
      $(this).toggleClass('is-active');

      if ($(this).hasClass('is-active')) {
        $('#music').get(0).play();
      } else {
        $('#music').get(0).pause();
      }
    });

    $('.header .nav a').on('click', function(e) {
      if (!this.hasAttribute('data-fancybox')) {
        e.preventDefault();

        const $el = $(this).attr('href');

        $('.header').removeClass('is-active');

        $('html, body').animate({
          scrollTop: $($el).offset().top + 30
        });
      }
    });

    $('html').addClass('is-ready');
  });
}(jQuery));
